import {useContext} from 'react'
import {ProductBadgesPageContext} from '../../context'
import Search from '../../../../components/Search'
import {useNavigate} from 'react-router-dom'

const ProductBadgesHeader = () => {
  const {hasWritePermission, onSearch} = useContext(ProductBadgesPageContext)
  const navigate = useNavigate()
  return (
    <div className='d-flex justify-content-between mb-10'>
      <Search
        onSearch={(searchTerm: string) => {
          onSearch && onSearch(searchTerm)
        }}
      />
      {hasWritePermission && (
        <>
          <button
            type='button'
            className='btn flex-end btn btn-primary'
            onClick={() => navigate('/products/product-badges/new')}
          >
            <span className='indicator-label'>+ Create a Badge</span>
          </button>
        </>
      )}
    </div>
  )
}
export default ProductBadgesHeader
